import { logger } from "utils";
import { ManageCoupons } from "apiEndPoints";
import APIrequest from "../../axios";

export const ManageCouponService = {
  getCouponListService: async ({ queryParams }) => {
    try {
      const payload = {
        ...ManageCoupons.getCoupon,
        queryParams,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  addCoupenService: async (bodyData) => {
    try {
      const payload = {
        ...ManageCoupons.addCoupon,
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getCoupenDetails: async (id) => {
    try {
      const payload = {
        ...ManageCoupons.getCouponById(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateCouponService: async (bodyData, id) => {
    try {
      const payload = {
        ...ManageCoupons.updateCoupon(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  deleteCoupon: async (id) => {
    try {
      const payload = {
        ...ManageCoupons.DeleteCoupon(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  updateStatus: async (bodyData, id) => {
    try {
      const payload = {
        ...ManageCoupons.updateCoupenStatus(id),
        bodyData,
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
  getConsumptionList: async (id) => {
    try {
      const payload = {
        ...ManageCoupons.usedCoupen(id),
      };
      const res = await APIrequest(payload);
      return res;
    } catch (error) {
      logger(error);
      throw error;
    }
  },
};
